import React from 'react';
import './style.css';
import Header from './components/Header';
import Services from './components/Services';
import Expertise from './components/Expertise';
import Differentiators from './components/Differentiators';
import Process from './components/Process';
import AgenticWorkflow from './components/AgenticWorkflow';
import SecondaryCTA from './components/SecondaryCTA';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <Services />
      <Expertise />
      <Differentiators />
      <Process />
      <AgenticWorkflow />
      <SecondaryCTA />
      <ContactForm />
      <Footer />
    </div>
  );
}

export default App;